(function () {
  'use strict';

  // ---- Money formatting ----
  function makeFormatter(moneyFormat) {
    return function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)))
        .replace('{{amount_with_apostrophe_separator}}', amount.replace('.', "'"));
    };
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ---- Build a table row from a variant data object ----
  function buildRow(v, formatMoney) {
    var isAvailable = v.available !== false && v.max_qty > 0;
    var maxQty  = v.max_qty  || 0;
    var minQty  = v.min_qty  || 1;
    var stepQty = v.step_qty || 1;

    var stockBadge;
    if (maxQty === 9999) {
      stockBadge = '<span class="fw-stock-badge fw-stock-badge--in">In Stock</span>';
    } else if (v.inventory_qty > 10) {
      stockBadge = '<span class="fw-stock-badge fw-stock-badge--in">In Stock</span>';
    } else if (v.inventory_qty > 0) {
      stockBadge = '<span class="fw-stock-badge fw-stock-badge--low">Low Stock</span>';
    } else {
      stockBadge = '<span class="fw-stock-badge fw-stock-badge--out">Out of Stock</span>';
    }

    var priceHtml = '';
    if (v.compare_at_price && v.compare_at_price > v.price) {
      priceHtml += '<span class="fw-price-compare">' + formatMoney(v.compare_at_price) + '</span>';
    }
    priceHtml += '<span class="fw-price-b2b">' + formatMoney(v.price) + '</span>';

    var imgHtml = v.image
      ? '<img class="fw-product-cell__img" src="' + escHtml(v.image) + '" alt="" width="52" height="52" loading="lazy">'
      : '<div class="fw-product-cell__img-placeholder">IMG</div>';

    var variantTitle = (v.variant_title && v.variant_title !== 'Default Title')
      ? '<span class="fw-product-cell__variant">' + escHtml(v.variant_title) + '</span>'
      : '';

    var disabledAttr = isAvailable ? '' : 'disabled';
    var wrapperClass = isAvailable ? 'fw-qty-wrapper' : 'fw-qty-wrapper fw-qty-wrapper--disabled';
    var rowClass     = isAvailable ? 'fw-order-form__row' : 'fw-order-form__row fw-row--disabled';

    // Search key includes barcode
    var searchKey = ((v.product_title || '') + ' ' + (v.sku || '') + ' ' + (v.barcode || '')).toLowerCase();

    var row = document.createElement('tr');
    row.className = rowClass;
    row.setAttribute('data-variant-id', String(v.variant_id));
    row.setAttribute('data-price', String(v.price));
    row.setAttribute('data-available', String(isAvailable));
    row.setAttribute('data-max', String(maxQty));
    row.setAttribute('data-search-key', searchKey);
    // Sort data attributes
    row.setAttribute('data-sort-product', ((v.product_title || '') + ' ' + (v.variant_title || '')).toLowerCase());
    row.setAttribute('data-sort-sku', (v.sku || '').toLowerCase());
    row.setAttribute('data-sort-barcode', (v.barcode || '').toLowerCase());
    row.setAttribute('data-sort-price', String(v.price));

    row.innerHTML = [
      '<td>',
        '<div class="fw-product-cell">',
          imgHtml,
          '<div class="fw-product-cell__info">',
            '<a class="fw-product-cell__name" href="' + escHtml(v.product_url || '/products/' + v.product_handle) + '">' + escHtml(v.product_title) + '</a>',
            variantTitle,
          '</div>',
        '</div>',
      '</td>',
      '<td><span class="fw-product-cell__sku">' + escHtml(v.sku || '—') + '</span></td>',
      '<td><span class="fw-product-cell__sku">' + escHtml(v.barcode || '—') + '</span></td>',
      '<td>' + stockBadge + '</td>',
      '<td class="fw-cell-price">' + priceHtml + '</td>',
      '<td class="fw-qty-cell">',
        '<div class="' + wrapperClass + '">',
          '<button type="button" class="fw-qty-btn fw-qty-btn--minus" aria-label="Decrease quantity" ' + disabledAttr + '>−</button>',
          '<input type="number" class="fw-qty-input" value="0" min="0" max="' + maxQty + '" step="' + stepQty + '" data-min="' + minQty + '" data-step="' + stepQty + '" ' + disabledAttr + '>',
          '<button type="button" class="fw-qty-btn fw-qty-btn--plus" aria-label="Increase quantity" ' + disabledAttr + '>+</button>',
        '</div>',
      '</td>',
      '<td class="fw-cell-total"><span class="fw-row-subtotal" data-row-total>—</span></td>'
    ].join('');

    return row;
  }

  // ---- Wire qty picker ----
  function wireRow(row, recalcFn) {
    var input    = row.querySelector('.fw-qty-input');
    var btnMinus = row.querySelector('.fw-qty-btn--minus');
    var btnPlus  = row.querySelector('.fw-qty-btn--plus');
    if (!input || !btnMinus || !btnPlus) return;

    var isAvailable = row.getAttribute('data-available') === 'true';
    var maxQty  = parseInt(row.getAttribute('data-max') || '0', 10);
    var minQty  = parseInt(input.getAttribute('data-min') || '1', 10);
    var stepQty = parseInt(input.getAttribute('data-step') || '1', 10);

    if (isAvailable) {
      input.removeAttribute('disabled');
      btnMinus.removeAttribute('disabled');
      btnPlus.removeAttribute('disabled');
    }

    function clamp(val, mn, mx) { return Math.min(Math.max(val, mn), mx); }
    function getVal() { return parseInt(input.value, 10) || 0; }

    function refresh() {
      var val   = getVal();
      var price = parseInt(row.getAttribute('data-price') || '0', 10);
      var totEl = row.querySelector('[data-row-total]');
      btnMinus.disabled = val <= 0;
      btnPlus.disabled  = maxQty > 0 ? val >= maxQty : true;
      if (totEl) totEl.textContent = val > 0 ? recalcFn.__fmt(price * val) : '—';
      recalcFn();
    }

    btnMinus.addEventListener('click', function () {
      var cur = getVal();
      input.value = cur <= minQty ? 0 : clamp(cur - stepQty, 0, maxQty);
      refresh();
    });

    btnPlus.addEventListener('click', function () {
      var cur = getVal();
      input.value = cur === 0 ? minQty : clamp(cur + stepQty, minQty, maxQty);
      refresh();
    });

    input.addEventListener('change', function () {
      var val = getVal();
      if (val > 0 && val < minQty) val = minQty;
      input.value = clamp(val, 0, maxQty);
      refresh();
    });

    input.addEventListener('input', function () {
      var price = parseInt(row.getAttribute('data-price') || '0', 10);
      var totEl = row.querySelector('[data-row-total]');
      if (totEl) totEl.textContent = getVal() > 0 ? recalcFn.__fmt(price * getVal()) : '—';
      recalcFn();
    });

    refresh();
  }

  // ---- Fetch all pages from /pages/b2b-products ----
function fetchAllProducts(callback) {
    var all = [];

    function fetchPage(page) {
      fetch('/pages/b2b-products?page=' + page)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var parsed;
          try {
            var match = text.match(/(\[[\s\S]*\])/);
            parsed = JSON.parse(match ? match[1] : text.trim());
          } catch (e) {
            parsed = [];
          }
          
          if (parsed && parsed.length > 0) {
            all = all.concat(parsed);
            
            // Count unique products in this payload
            var uniqueProductIds = [];
            for (var i = 0; i < parsed.length; i++) {
              if (uniqueProductIds.indexOf(parsed[i].product_id) === -1) {
                uniqueProductIds.push(parsed[i].product_id);
              }
            }

            // If we received exactly 50 products, fetch the next page
            if (uniqueProductIds.length === 50) {
              fetchPage(page + 1);
            } else {
              callback(all);
            }
          } else {
            callback(all);
          }
        })
        .catch(function () { callback(all); });
    }

    fetchPage(1);
  }
    // ---- Sorting ----
  function applySort(tbody, sortKey, sortDir) {
    var rows = Array.prototype.slice.call(tbody.querySelectorAll('.fw-order-form__row'));

    rows.sort(function (a, b) {
      var aVal = a.getAttribute('data-sort-' + sortKey) || '';
      var bVal = b.getAttribute('data-sort-' + sortKey) || '';

      if (sortKey === 'price') {
        aVal = parseFloat(aVal) || 0;
        bVal = parseFloat(bVal) || 0;
        return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
      }

      return sortDir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    });

    var frag = document.createDocumentFragment();
    rows.forEach(function (row) { frag.appendChild(row); });
    tbody.appendChild(frag);
  }

  function updateSortHeaders(headers, activeKey, activeDir) {
    headers.forEach(function (th) {
      var key = th.getAttribute('data-sort-key');
      th.classList.remove('fw-th--asc', 'fw-th--desc');
      th.setAttribute('aria-sort', 'none');
      if (key === activeKey) {
        th.classList.add(activeDir === 'asc' ? 'fw-th--asc' : 'fw-th--desc');
        th.setAttribute('aria-sort', activeDir === 'asc' ? 'ascending' : 'descending');
      }
    });
  }

  // ---- Main init ----
  function initOrderForm(formEl) {
    var moneyFormat = formEl.getAttribute('data-money-format') || '${{amount}}';
    var formatMoney = makeFormatter(moneyFormat);

    var addBtn     = formEl.querySelector('[data-fw-add-btn]');
    var grandTotal = formEl.querySelector('[data-fw-grand-total]');
    var feedback   = formEl.querySelector('[data-fw-feedback]');
    var searchEl   = formEl.querySelector('[data-fw-search]');
    var tbody      = formEl.querySelector('[data-fw-tbody]');
    var tableWrap  = formEl.querySelector('[data-fw-table-wrap]');
    var loadingEl  = formEl.querySelector('[data-fw-panel-loading]');
    var emptyEl    = formEl.querySelector('[data-fw-panel-empty]');

    if (!addBtn || !grandTotal || !tbody) return;

    var activeVariantIds = null;
    var activeSearch     = '';
    var activeSortKey    = null;
    var activeSortDir    = 'asc';

    function recalcGrandTotal() {
      var total  = 0;
      var hasAny = false;
      tbody.querySelectorAll('.fw-order-form__row').forEach(function (row) {
        var input = row.querySelector('.fw-qty-input');
        var qty   = input ? (parseInt(input.value, 10) || 0) : 0;
        if (qty > 0) {
          total += parseInt(row.getAttribute('data-price') || '0', 10) * qty;
          hasAny = true;
        }
      });
      grandTotal.textContent = formatMoney(total);
      addBtn.disabled = !hasAny;
    }
    recalcGrandTotal.__fmt = formatMoney;

    function applyFilter() {
      var q = activeSearch.trim().toLowerCase();
      tbody.querySelectorAll('.fw-order-form__row').forEach(function (row) {
        var vid         = row.getAttribute('data-variant-id');
        var searchKey   = row.getAttribute('data-search-key') || '';
        var tabMatch    = !activeVariantIds || activeVariantIds[vid] === true;
        var searchMatch = !q || searchKey.indexOf(q) !== -1;
        row.classList.toggle('fw-row--hidden', !(tabMatch && searchMatch));
      });
      var anyVisible = !!tbody.querySelector('.fw-order-form__row:not(.fw-row--hidden)');
      if (emptyEl) emptyEl.style.display = anyVisible ? 'none' : 'block';
    }

    var tabs = formEl.querySelectorAll('[data-fw-tab]');

    function activateTab(tabEl) {
      tabs.forEach(function (t) {
        var active = t === tabEl;
        t.classList.toggle('fw-tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      var tabKey = tabEl.getAttribute('data-fw-tab');
      if (tabKey === 'all') {
        activeVariantIds = null;
      } else {
        var raw = (tabEl.getAttribute('data-fw-variant-ids') || '').trim();
        var ids = [];
        try {
          var parsed = JSON.parse(raw);
          if (typeof parsed === 'string') parsed = JSON.parse(parsed);
          if (Array.isArray(parsed)) {
            ids = parsed.map(function (id) {
              var str = String(id);
              var slash = str.lastIndexOf('/');
              return slash !== -1 ? str.slice(slash + 1) : str;
            });
          }
        } catch (e) {
          ids = raw.split(',').map(function (id) { return id.trim(); }).filter(Boolean);
        }
        activeVariantIds = {};
        ids.forEach(function (id) { activeVariantIds[id] = true; });
      }

      applyFilter();
      recalcGrandTotal();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(tab); });
    });

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        activeSearch = this.value;
        applyFilter();
      });
    }

    fetchAllProducts(function (variants) {
      if (loadingEl) loadingEl.style.display = 'none';

      if (!variants || variants.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      if (tableWrap) tableWrap.style.display = 'block';

      var frag = document.createDocumentFragment();
      variants.forEach(function (v) { frag.appendChild(buildRow(v, formatMoney)); });
      tbody.appendChild(frag);

      tbody.querySelectorAll('.fw-order-form__row').forEach(function (row) {
        wireRow(row, recalcGrandTotal);
      });

      // ---- Wire sortable column headers ----
      var sortHeaders = Array.prototype.slice.call(formEl.querySelectorAll('[data-sort-key]'));
      sortHeaders.forEach(function (th) {
        th.addEventListener('click', function () {
          var key = th.getAttribute('data-sort-key');
          if (activeSortKey === key) {
            activeSortDir = activeSortDir === 'asc' ? 'desc' : 'asc';
          } else {
            activeSortKey = key;
            activeSortDir = 'asc';
          }
          applySort(tbody, activeSortKey, activeSortDir);
          updateSortHeaders(sortHeaders, activeSortKey, activeSortDir);
        });
      });

      var activeTab = formEl.querySelector('.fw-tab--active');
      if (activeTab) activateTab(activeTab);
    });

    function showFeedback(msg, type) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.className = 'fw-order-form__feedback fw-feedback--' + type;
      clearTimeout(feedback._timer);
      feedback._timer = setTimeout(function () {
        feedback.className = 'fw-order-form__feedback';
      }, 5000);
    }

    addBtn.addEventListener('click', function () {
      var items = [];
      tbody.querySelectorAll('.fw-order-form__row').forEach(function (row) {
        var input = row.querySelector('.fw-qty-input');
        var qty   = input ? (parseInt(input.value, 10) || 0) : 0;
        if (qty > 0) {
          items.push({
            id: parseInt(row.getAttribute('data-variant-id'), 10),
            quantity: qty
          });
        }
      });

      if (items.length === 0) return;

      addBtn.disabled = true;
      addBtn.classList.add('fw-btn--loading');
      addBtn.textContent = 'Adding…';

      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error adding to cart'); });
        return r.json();
      })
      .then(function () {
        showFeedback('Items added to cart!', 'success');
        tbody.querySelectorAll('.fw-order-form__row').forEach(function (row) {
          var inp = row.querySelector('.fw-qty-input');
          if (inp) inp.value = 0;
          var tot = row.querySelector('[data-row-total]');
          if (tot) tot.textContent = '—';
        });
        recalcGrandTotal();
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function (err) {
        showFeedback(err.message || 'Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        addBtn.classList.remove('fw-btn--loading');
        addBtn.textContent = 'Add to Cart';
        recalcGrandTotal();
      });
    });
  }

  // ---- Boot ----
  function tryInit() {
    document.querySelectorAll('[data-fw-order-form]:not([data-fw-init])').forEach(function (formEl) {
      formEl.setAttribute('data-fw-init', '1');
      initOrderForm(formEl);
    });
  }

  tryInit();
  new MutationObserver(tryInit).observe(document.documentElement, { childList: true, subtree: true });

})();
